import { QueryClient } from "@tanstack/react-query";
import { QUERY_KEYS } from "../constants/QueryKeys";

/**
 * Everything a decision on many conflicts moves: the organization's own statistics, the five entity lists and their
 * conflict-group queries, the per-file lists whose conflict state changed, the audit log the operation wrote an entry
 * to, the migration queue the decided files landed in, the org-wide resolve's pre-flight, and the rule page's case
 * search, which offers only cases that still hold a conflict.
 */
export const CONFLICT_DECISION_QUERY_KEYS: string[] = [
  QUERY_KEYS.ORGANIZATION,
  QUERY_KEYS.ORGANIZATIONS,
  QUERY_KEYS.ORG_CONFLICT_PREFLIGHT,
  QUERY_KEYS.RULE_CASE_SEARCH,
  QUERY_KEYS.CASES,
  QUERY_KEYS.CASE,
  QUERY_KEYS.INTAKES,
  QUERY_KEYS.INTAKE,
  QUERY_KEYS.PROVIDERS,
  QUERY_KEYS.PROVIDER,
  QUERY_KEYS.TEMPLATES,
  QUERY_KEYS.TEMPLATE,
  QUERY_KEYS.FIRM_DOCUMENTS_FOLDERS,
  QUERY_KEYS.FIRM_DOCUMENTS_FOLDER,
  QUERY_KEYS.CASE_FILES,
  QUERY_KEYS.CASE_FILES_FILTERS,
  QUERY_KEYS.INTAKE_FILES,
  QUERY_KEYS.INTAKE_FILES_FILTERS,
  QUERY_KEYS.PROVIDER_FILES,
  QUERY_KEYS.TEMPLATE_FILES,
  QUERY_KEYS.FIRM_DOCUMENTS,
  QUERY_KEYS.CASE_CONFLICT_GROUPS,
  QUERY_KEYS.INTAKE_CONFLICT_GROUPS,
  QUERY_KEYS.PROVIDER_CONFLICT_GROUPS,
  QUERY_KEYS.TEMPLATE_CONFLICT_GROUPS,
  QUERY_KEYS.FIRM_DOCUMENTS_CONFLICT_GROUPS,
  QUERY_KEYS.MIGRATION_QUEUE_STATUS,
  QUERY_KEYS.AUDIT_LOGS,
];

/**
 * Marks every query a bulk conflict decision moved as stale. Call it only after the organization's dirty statistics
 * have been recalculated: each decided file only flags its parent's statistics row dirty, so invalidating first would
 * refetch the pre-decision counts and cache them as fresh.
 */
export const invalidateConflictDecisionQueries = (queryClient: QueryClient): Promise<void[]> =>
  Promise.all(CONFLICT_DECISION_QUERY_KEYS.map((key) => queryClient.invalidateQueries({ queryKey: [key] })));
